import { Button, Icon, Image, Link, Text, View } from "@/components";

import useDropdown from "@/hooks/useDropdown";
import { useLayout, useNavigator } from "@/providers";
import cn from "@/utils/cn";
import type { JSX } from "react";

// TODO: Improve profile links management
const profileLinks = [
  {
    icon: "fa-solid fa-user",
    url: "/backoffice/edit-profile",
    title: "My Profile"
  },
  {
    icon: "fa-solid fa-right-from-bracket",
    url: "/signOut",
    title: "Logout"
  }
];
export interface ProfileProps {
  className?: string;
}

const Profile = ({ className }: ProfileProps): JSX.Element => {
  const { userAuth } = useLayout();
  const { navigate } = useNavigator();
  const { open, ref, toggleOpen } = useDropdown();

  const onClickIcon = () => {
    if (userAuth) {
      toggleOpen();
    } else {
      navigate("/signIn");
    }
  };

  const UserPicture = userAuth?.photoURL ? (
    <Image
      width={48}
      height={48}
      loading="eager"
      className="w-full h-full object-cover rounded-full"
      alt={`${userAuth?.name} ${userAuth?.lastName}` || "User Profile"}
      src={userAuth?.photoURL || "/icons/icon-48x48.png"}
    />
  ) : (
    <View className="btn-rounded">
      <Icon name="fa-solid fa-user" size="2x" aria-hidden="true" />
    </View>
  );

  return (
    <View
      className={cn("relative shrink-0 flex items-center", className)}
      ref={ref}
    >
      <Button
        type="button"
        className="cursor-pointer w-12 h-12"
        onClick={onClickIcon}
      >
        {UserPicture}
      </Button>
      <View
        className={`bg-popover border-2 border-border z-[21] rounded-md ltr:origin-top-right rtl:origin-top-left ltr:right-0 rtl:left-0 shadow-lg absolute top-full transition-all duration-300 ${open ? "opacity-100 scale-100 visible" : "opacity-0 scale-0 invisible"}`}
      >
        <View className="flex flex-col text-center items-center lg:p-4 p-3 border-b border-border">
          <View className="w-12 h-12">{UserPicture}</View>
          <Text type="h6" className="mt-2 text-popover-foreground">
            {userAuth?.name || "User Profile"}
          </Text>
          <Text type="p" className="text-sm text-muted-foreground">
            {userAuth?.email || "user@mail.com"}
          </Text>
        </View>
        <View type="ul" className="flex flex-col gap-2 w-[250px] py-4 px-2">
          {profileLinks?.map(({ icon, title, url }) => (
            <View type="li" key={title}>
              <Link
                href={url}
                onClick={() => toggleOpen()}
                className="flex items-center gap-2 p-2 rounded-md transition duration-300 hover:bg-primary hover:text-primary-foreground text-popover-foreground"
              >
                <Text>
                  <Icon
                    name={icon}
                    className="pr-2"
                    size="2x"
                    aria-hidden="true"
                  />
                </Text>
                {title}
              </Link>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
};

export default Profile;
